import {CSSProperties, FC} from 'react';


export interface IIconOdnoklassnikiProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconOdnoklassniki: FC<IIconOdnoklassnikiProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M12.011 9.945a2.054 2.054 0 0 0 2.055-2.073A2.058 2.058 0 0 0 12 5.81a2.062 2.062 0 0 0-2.07 2.089 2.059 2.059 0 0 0 2.081 2.047Z" />
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm.017 3.65c2.338.006 4.214 1.918 4.202 4.28-.012 2.31-1.919 4.18-4.252 4.173-2.31-.008-4.204-1.923-4.19-4.236a4.233 4.233 0 0 1 4.24-4.218Zm4.734 10.113a5.081 5.081 0 0 1-1.83 1.183c-.653.253-1.368.38-2.077.465.107.117.158.174.225.24.961.967 1.927 1.929 2.885 2.898.327.33.395.74.215 1.124-.196.42-.636.696-1.068.666-.274-.019-.487-.154-.676-.345-.726-.73-1.466-1.448-2.176-2.192-.208-.216-.307-.175-.49.013-.73.752-1.472 1.492-2.218 2.228-.335.33-.734.39-1.122.201-.414-.2-.676-.622-.656-1.046.014-.287.155-.506.352-.702.952-.95 1.9-1.903 2.85-2.855.063-.063.121-.13.213-.229-1.295-.135-2.462-.453-3.462-1.235-.124-.097-.252-.191-.365-.3-.438-.42-.481-.902-.136-1.397.297-.424.794-.538 1.31-.294.1.047.196.106.287.17 1.863 1.28 4.422 1.314 6.292.056.185-.14.383-.257.613-.316a.961.961 0 0 1 1.1.44c.275.446.271.88-.066 1.227Z" />
        </svg>
    );
};
